<template>
  <div>
    <!-- <div class="overmask" :style="returnaCor('alphaLogin', false, true)"></div> -->
    <div id="Login" class="">
      <Loading :visible="carregando" />

      <DeviceWarning v-if="!isMobile()" :logo="logo" />
      <div v-else>
        <b-row class="mt-5 text-center" v-if="erroConexao != ''">
          <b-col>
            <div class="logo">
              <img :src="logo" style="max-width: 90%" />
            </div>
            <div class="alert alert-warning">{{ erroConexao }}</div>
            <b-button @click="buscaDadosEmpresa()">Tentar Novamente</b-button>
          </b-col>
        </b-row>
        <div
          v-else-if="empresaNaoPermiteAssociadoLogarApp"
          class="not-allowed-wrapper"
        >
          <div class="not-allowed-card">
            <h1 class="not-allowed-code">403</h1>
            <h2 class="not-allowed-title">Ops! Acesso não autorizado</h2>
            <p class="not-allowed-message">
              Entre em contato com a Assistência 24h para mais informações.
            </p>
          </div>
        </div>
        <b-row v-else class="">
          <b-col class="text-center">
            <div v-if="form.formSelecionado === 0">
              <BrandIntro />
              <BrandButtonGroup
                :onClientClick="() => selecionaTab(1)"
                :solutionsLink="'https://www.bpseguradora.com.br/'"
              />
            </div>
            <b-form
              v-if="form.formSelecionado === 1"
              @submit.stop.prevent="onSubmit"
              class="container vh-100 center-content"
            >
              <div>
                <BpCustomColorLogo width="128" height="72" />
              </div>
              <div class="section-enter-data">
                <b-form-group
                  id="input-group-2"
                  label
                  label-for="input-2"
                  class="w-100 mb-0"
                >
                  <p class="label-input text-left pl-4">CPF / CNPJ</p>
                  <b-form-input
                    type="text"
                    inputmode="numeric"
                    class="login-input form-control"
                    v-model="form.cpfcnpj"
                    id="cpfcnpj"
                    name="cpfcnpj"
                    :class="{ 'is-invalid': taxIdError }"
                    style="width: 100%"
                    @input="onTaxIdInput"
                    maxlength="18"
                    @keypress="onlyNumeric"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  v-if="resetSenha"
                  id="input-group-4"
                  class="w-100 mb-0"
                >
                  <p class="label-input text-left pl-4">
                    Confirme o e-mail cadastrado
                  </p>
                  <div class="position-relative w-100">
                    <b-form-input
                      id="Email"
                      name="Email"
                      class="login-input form-control"
                      :value="form.email"
                      @input="form.email = $event.toLowerCase()"
                      type="email"
                    />
                  </div>
                </b-form-group>

                <b-form-group v-else id="input-group-4" class="w-100 mb-0">
                  <p class="label-input text-left pl-4">Senha</p>
                  <div class="position-relative w-100">
                    <b-form-input
                      id="Senha"
                      name="Senha"
                      class="login-input form-control"
                      v-model="form.senha"
                      :type="tipoInputSenha"
                    />

                    <span
                      class="position-absolute"
                      style="
                        top: 50%;
                        right: 12px;
                        transform: translateY(-50%);
                        cursor: pointer;
                      "
                      @click="exibirSenha"
                    >
                      <i :class="[iconIputSenha]"></i>
                    </span>
                  </div>
                </b-form-group>
                <b-button
                  v-if="resetSenha"
                  type="button"
                  :disabled="submitLoading"
                  @click.stop.prevent="gerarCodigoResetSenha"
                  class="button-warning"
                >
                  <b-spinner
                    small
                    v-if="submitLoading"
                    class="mr-2"
                  ></b-spinner>
                  {{ submitLoading ? 'Aguarde...' : 'Continuar' }}
                </b-button>
                <b-button
                  :disabled="submitLoading"
                  v-else
                  type="submit"
                  class="button-blue"
                >
                  <b-spinner
                    small
                    v-if="submitLoading"
                    class="mr-2"
                  ></b-spinner>
                  {{ submitLoading ? 'Aguarde...' : 'Entrar' }}</b-button
                >
                <button
                  v-if="resetSenha"
                  class="button-reset-password"
                  @click.stop.prevent="resetSenha = false"
                >
                  Voltar para Login
                </button>
                <button
                  v-else
                  class="button-reset-password"
                  @click.stop.prevent="resetSenha = true"
                >
                  Redefinir Senha
                </button>
              </div>
              <div style="height: 100%; max-height: 150px; visibility: hidden">
                <BpCustomColorLogo width="128" height="72" />
              </div>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalCodigoVerificacao
      :show="showModalCodigoVerificacao"
      @close="showModalCodigoVerificacao = false"
      @verify="handleVerify"
    />
    <ModalNovaSenha
      :show="showModalNovaSenha"
      @close="showModalNovaSenha = false"
      @submit="atualizarSenha"
      @success="senhaAtualizada"
    />
  </div>
</template>

<script>
import service from '../services';
import utils from '../services/utils';
import DeviceWarning from './DeviceWarning.vue';
import deviceDetection from '../mixins/deviceDetection';
import { WHATSAPP, SMS } from './../shared/global';
import {
  saveIdEmpresa,
  saveIdEmpresaDefault,
  saveIdUsuarioInitialLogin,
  saveListEmpresas,
} from './../services/multiple-empresa';
import { decryptData } from '../services/decryptData';
import { formatTaxId } from '../utils/formatTaxId';
import { validateTaxId } from '../utils/validTaxId';
// import Axios from 'axios';
import Loading from './ui/Loading.vue';
import BpCustomColorLogo from '../assets/icones/BpCustomColorLogo.vue';
import BrandIntro from './ui/BrandIntro.vue';
import BrandButtonGroup from './ui/BrandButtonGroup.vue';
import ModalCodigoVerificacao from './ModalCodigoVerificacao.vue';
import ModalNovaSenha from './ModalNovaSenha.vue';

export default {
  name: 'DashBoard',
  mixins: [deviceDetection],
  props: {
    msg: String,
  },
  data() {
    return {
      taxId: '',
      email: '',
      taxIdError: false,
      cellphone: null,
      cellphoneError: false,
      utils: utils,
      cotacaoEncontrada: false,
      chaveProposta: null,
      dadosProposta: null,
      placaValida: null,
      chassiValido: null,
      btnDisabled: true,
      placa: null,
      chassi: null,
      form: {
        placa: null,
        email: null,
        emailConsultor: null,
        senha: null,
        idEmpresa: null,
        nf: null,
        formSelecionado: 0,
        cpfcnpj: null,
        codigoVerificacao: null,
      },
      checked: null,
      tipoInputSenha: 'password',
      iconIputSenha: 'fa fa-eye',
      idEmpresa: this.$route.query.idEmpresa.replace('/', ''),

      consultorEsqueceuSenha: false,
      consultorEncontrado: false,
      dadosConsultorRecuperados: {
        nome: null,
        email: null,
        cpf: null,
        celular: null,
      },
      isCarroZero: false,
      empresas: [],
      empresasAux: [],
      erroConexao: '',
      empresaNaoPermiteAssociadoLogarApp: false,
      carregando: true,
      logo: '',
      trocouLogo: false,
      value: 80,
      max: 100,
      pathRedirect: null,
      temaCor: {
        botaoLogin: '#000000',
        alphaLogin: '#000000',
        botaoFormularios: '#000000',
      },
      contando: false,
      contador: 45,
      desabilitar: false,
      sentWhatsapp: 0,
      selectedMethodSend: WHATSAPP,
      WHATSAPP: WHATSAPP,
      SMS: SMS,
      showModalNovaSenha: false,
      isNewVehicle: false,
      showModalCodigoVerificacao: false,
      resetSenha: false,
      esqueciSenha: false,
      submitLoading: false,
    };
  },
  components: {
    DeviceWarning,
    Loading,
    BpCustomColorLogo,
    BrandIntro,
    BrandButtonGroup,
    ModalCodigoVerificacao,
    ModalNovaSenha,
  },
  created: function () {
    this.atualizaManifest();
    this.$watch('form', this.colocaImagem, {
      deep: true,
    });
  },
  watch: {
    resetSenha(newValue) {
      if (newValue) {
        this.form.senha = '';
        return;
      }
      this.form.email = '';
    },
  },
  methods: {
    validateTaxId() {
      if (!validateTaxId(this.form.cpfcnpj)) {
        this.taxIdError = true;
        return false;
      }

      this.taxIdError = false;
      return true;
    },

    colocaImagem() {
      if (
        this.trocouLogo ||
        !this.form.idEmpresa ||
        this.empresasAux.length === 0
      ) {
        return;
      }

      const empresa = this.empresasAux.find(
        (empresa) => empresa.idEmpresa == this.form.idEmpresa,
      );

      if (empresa) {
        this.logo = empresa.logo;
        this.trocouLogo = true;
      }
    },
    selecionaTab(valor) {
      this.form.senha = '';
      this.form.formSelecionado = valor;
      if (valor == 1) {
        document.body.className = 'associado';
        this.verificarSeContando();
      }
      if (valor == 2) document.body.className = 'consultor';
      if (this.form.idEmpresa == 29) {
        document.body.className = document.body.className + ' carvip';
      }

      if (utils.verificaEmpresaBemProtege(this.form.idEmpresa)) {
        document.body.className = document.body.className + ' bp';
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        !this.veeFields[ref] ||
        (!this.veeFields[ref].dirty && !this.veeFields[ref].validated)
      ) {
        return null;
      }

      return this.veeErrors.has(ref)
        ? 'border border-danger'
        : 'border border-success';
    },
    popToast() {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;

      var arrMsg = this.$validator.errors.all();
      var arrAux = [];
      arrMsg.forEach((element) => {
        arrAux.push(h('p', {}, element));
      });
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, arrAux);

      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: 'Atenção!',
        solid: true,
        variant: 'danger',
        toaster: 'b-toaster-top-full',
        appendToast: false,
        autoHideDelay: 2500,
      });
    },
    async onSubmit() {
      this.desabilitar = true;

      try {
        if (!this.validateTaxId()) {
          this.showMessage(
            'Por favor, preencha um CPF ou CNPJ válido.',
            'warning',
          );
          return;
        }
        if (!this.form.senha || this.form.senha.length < 6) {
          this.showMessage(
            'Por favor, preencha a senha corretamente.',
            'warning',
          );
          return;
        }
        this.submitLoading = true;
        const { email } = await this.signIn();
        this.form.email = email;
        this.showModalCodigoVerificacao = true;
      } catch (error) {
        if (error === 'Login no app não permitido!') {
          this.empresaNaoPermiteAssociadoLogarApp = true;
        } else {
          this.showMessage(
            'Ocorreu um erro no processo de autenticação.',
            'danger',
          );
        }
      } finally {
        this.desabilitar = false;
        this.submitLoading = false;
      }
    },
    async signIn() {
      const { data } = await service.login(
        'Login',
        'MakeLoginAssociado',
        this.form,
      );
      return data;
    },
    handleSuccessfulSignIn(data) {
      const { token, redirect, dadosRes } = data;

      if (token) {
        localStorage.setItem('user-token', token);
        saveIdUsuarioInitialLogin(token);
        saveIdEmpresa(token);
      }

      const empresasAssociado = dadosRes?.empresas || dadosRes?.id_empresa;
      const idEmpresaDefaultAssociado =
        dadosRes?.idEmpresaDefault || dadosRes?.id_empresa;

      saveListEmpresas(empresasAssociado);
      saveIdEmpresaDefault(idEmpresaDefaultAssociado);

      if (dadosRes) {
        localStorage.setItem('dadosRes', JSON.stringify(dadosRes));
      }

      this.$router.push({ path: redirect });
    },
    showMessage(message, variant = 'danger') {
      utils.showToast(this.$bvToast, message, variant);
    },

    direcionaCotacaoOnline(isRedirect) {
      const urlOrigem = window.location.origin;

      //Para uso em QA
      if (urlOrigem.includes('qa.app')) {
        const novaUrl = urlOrigem.replace('qa.app', 'qa.adm');
        const redirect = `${novaUrl}/novaProposta/${this.form.idEmpresa}?insideApp=true`;
        if (isRedirect) window.location = redirect;
        return redirect;
      }

      //Para uso em ambiente local caso a porta do APP seja 8080 e a do ADM seja 8081
      if (urlOrigem.includes('localhost:8080')) {
        const novaUrl = urlOrigem.replace('8080', '8081');
        const redirect = `${novaUrl}/novaProposta/${this.form.idEmpresa}?insideApp=true`;
        if (isRedirect) window.location = redirect;
        return redirect;
      }

      //Para uso em ambiente local caso a porta do APP seja 8081 e a do ADM seja 8080
      if (urlOrigem.includes('localhost:8081')) {
        const novaUrl = urlOrigem.replace('8081', '8080');
        const redirect = `${novaUrl}/novaProposta/${this.form.idEmpresa}?insideApp=true`;
        if (isRedirect) window.location = redirect;
        return redirect;
      }

      //Para uso em produção
      const novaUrl = urlOrigem.replace('app', 'adm');
      const redirect = `${novaUrl}/novaProposta/${this.form.idEmpresa}?insideApp=true`;
      if (isRedirect) window.location = redirect;
      return redirect;
    },
    atualizaManifest() {
      this.form.idEmpresa = this.$route.query.idEmpresa.replace('/', '');
      const manifest = document.getElementById('manifest');
      manifest.href = `/manifest_${this.form.idEmpresa}.json`;
    },
    returnaOnlyBorder() {
      return `
        border:2px solid #2B50BB;
        background-color: transparent;
        color:#FFF;
      `;
    },
    returnaCor(chave, comSombra, backgroundTransparent) {
      return utils.returnCor(
        this.temaCor,
        chave,
        comSombra,
        backgroundTransparent,
      );
    },
    buscaDadosEmpresa() {
      return new Promise((resolve) => {
        document.body.className = 'home';
        this.carregando = true;
        this.form.idEmpresa = this.$route.query.idEmpresa.replace('/', '');
        if (this.form.idEmpresa == 29) {
          document.body.className = document.body.className + ' carvip';
        }
        if (utils.verificaEmpresaBemProtege(this.form.idEmpresa)) {
          document.body.className = document.body.className + ' bp';
        }
        if (this.$route.query.cpfcnpj) {
          this.cpf = this.$route.query.cpfcnpj;
          this.form.cpfcnpj = this.$route.query.cpfcnpj;
          this.form.placa = this.$route.query.placa;
          this.selecionaTab(1);
        }

        if (this.$route.query.token && this.isMobile()) {
          localStorage.setItem('user-token', this.$route.query.token);
          window.location = `${window.location.origin}/AceiteCotacao/${this.$route.query.chave}`;
        }

        //this.mockSwipeList[0].push(this.template2);
        if (!this.form.idEmpresa) {
          service
            .getAll('g', {}, 'empresas/list')
            .then((res) => {
              res.data = decryptData(res.data);

              this.empresas = [{ value: '', text: 'Selecione' }];
              this.empresasAux = res.data;
              res.data.forEach((el) => {
                this.empresas.push({
                  value: el.idEmpresa,
                  text: el.nome,
                });
              });

              this.carregando = false;
              resolve();
            })
            .catch(() => {
              this.carregando = false;
              this.erroConexao =
                'Seu aplicativo parece estar offline, verifique sua conexao';
            });
        } else {
          service
            .getAll('Login', {}, 'buscarEmpresa/' + this.form.idEmpresa)
            .then((res) => {
              res.data = decryptData(res.data);

              this.trocouLogo = true;
              this.logo = res.data.logo;
              localStorage.setItem('logo', this.logo);
              const favicon = document.getElementById('favicon');
              favicon.href = this.logo;

              document.title = res.data.nome;
              if (res.data.temaCor) {
                localStorage.setItem('temaCor', res.data.temaCor);
                var tema = JSON.parse(res.data.temaCor);
                this.temaCor = tema;
              }
              this.carregando = false;
              resolve();
            })
            .catch(() => {
              this.carregando = false;
              this.erroConexao =
                'Seu aplicativo parece estar offline, verifique sua conexao';
            });
        }
      });
    },
    exibirSenha() {
      if (this.tipoInputSenha === 'password') {
        this.tipoInputSenha = 'text';
        this.iconIputSenha = 'fa fa-eye-slash';
        return;
      }

      this.tipoInputSenha = 'password';
      this.iconIputSenha = 'fa fa-eye';
    },
    getMessage(res) {
      if (res.data.celular || res.data.sentWhatsapp) {
        return `Sua nova senha foi enviada para o celular ${utils.escondeCelular(
          res.data.celular,
        )}`;
      }

      if (res.data.email) {
        return `Sua nova senha foi enviada para o email ${utils.escondeEmail(
          res.data.email,
        )}`;
      }
    },
    contagemRegressiva() {
      this.mostrarContador();
      localStorage.setItem('contando', 'contando');
      const diminuir1Segundo = setInterval(() => {
        this.contador--;
        this.contador === 0 && clearInterval(diminuir1Segundo);
        this.contador === 0 && localStorage.removeItem('contando');
        this.contador === 0 && this.mostrarContador();
      }, 1000);
    },
    mostrarContador() {
      this.contando = !this.contando;
      this.contador = 45;
    },
    verificarSeContando() {
      if (localStorage.getItem('contando')) {
        this.contagemRegressiva();
      }
    },
    countSentWhatsapp(res) {
      this.sentWhatsapp += res.data.sentWhatsapp ? 1 : 0;
    },
    keymonitorPlacaChassi(tipo) {
      if (tipo !== 'placa' && tipo !== 'chassi') {
        return;
      }

      if (tipo === 'placa') {
        this.chassi = null;
        if (this.placa.length !== 8) {
          this.cotacaoEncontrada = false;
          this.btnDisabled = true;
          return;
        }
        this.buscaPropostaPorPlacaChassi();
        return;
      }

      if (tipo === 'chassi') {
        this.placa = null;
        if (this.chassi.length !== 17) {
          this.cotacaoEncontrada = false;
          this.btnDisabled = true;
          return;
        }
        this.buscaPropostaPorPlacaChassi();
      }
    },
    async buscaPropostaPorPlacaChassi() {
      service;
      const result = await this.$validator.validateAll();
      if (!result) {
        this.popToast();
        return;
      }

      this.carregando = true;

      try {
        const objSend = {
          placa: this.placa,
          chassi: this.chassi,
          idEmpresa: Number(this.idEmpresa),
        };

        const res = await service.post(
          'CotacaoAberta',
          'buscaPropostaPorPlacaChassi',
          objSend,
        );

        this.dadosProposta = res.data[0];
        this.chaveProposta = this.dadosProposta.chave;
        this.cotacaoEncontrada = true;
        this.btnDisabled = false;
        this.carregando = false;
      } catch (e) {
        this.cotacaoEncontrada = false;
        this.btnDisabled = true;
        this.carregando = false;
        this.$bvToast.toast(e, {
          title: 'Atenção!',
          solid: true,
          variant: 'danger',
          toaster: 'b-toaster-top-full',
          appendToast: false,
          autoHideDelay: 3000,
        });
      }
    },
    direcionaCotacaoExistente() {
      if (this.chaveProposta) {
        const urlOrigem = window.location.origin;

        //Para uso em QA
        if (urlOrigem.includes('qa.app')) {
          const novaUrl = urlOrigem.replace('qa.app', 'qa.adm');
          const redirect = `${novaUrl}/propostas/${this.chaveProposta}`;
          window.location = redirect;
          return redirect;
        }

        //Para uso em ambiente local caso a porta do APP seja 8080 e a do ADM seja 8081
        if (urlOrigem.includes('localhost:8080')) {
          const novaUrl = urlOrigem.replace('8080', '8081');
          const redirect = `${novaUrl}/propostas/${this.chaveProposta}`;
          window.location = redirect;
          return redirect;
        }

        //Para uso em ambiente local caso a porta do APP seja 8081 e a do ADM seja 8080
        if (urlOrigem.includes('localhost:8081')) {
          const novaUrl = urlOrigem.replace('8081', '8080');
          const redirect = `${novaUrl}/propostas/${this.chaveProposta}`;
          window.location = redirect;
          return redirect;
        }

        //Para uso em produção
        const novaUrl = urlOrigem.replace('app', 'adm');
        const redirect = `${novaUrl}/propostas/${this.chaveProposta}`;
        window.location = redirect;
        return redirect;
      }
    },
    onTaxIdInput() {
      if (this.taxIdError) {
        this.taxIdError = false;
      }

      this.form.cpfcnpj = formatTaxId(this.form.cpfcnpj);

      const cleanValue = this.form.cpfcnpj.replace(/\D/g, '');
      if (cleanValue.length === 11 || cleanValue.length === 14) {
        this.taxIdError = !validateTaxId(this.form.cpfcnpj);
      }
    },
    onlyNumeric(event) {
      const isNumber = /[0-9]/.test(event.key);

      if (!isNumber) {
        event.preventDefault();
        return false;
      }
    },

    async verificaoLogin({ codigoVerificacao, onSuccess, onError, onFinish }) {
      try {
        this.form.codigoVerificacao = codigoVerificacao;
        const { data } = await service.login(
          'Login',
          'MakeLoginAssociado/codigoAcesso',
          this.form,
        );

        if (data.dadosRes.trocarSenha) {
          this.showModalNovaSenha = true;
          return;
        }

        onSuccess();
        this.showModalCodigoVerificacao = false;
        this.handleSuccessfulSignIn(data);
      } catch (err) {
        onError('Código inválido ou expirado');
      } finally {
        onFinish();
      }
    },

    async verificaoResetSenha({
      codigoVerificacao,
      onSuccess,
      onError,
      onFinish,
    }) {
      this.form.codigoVerificacao = codigoVerificacao;
      this.form.esqueciSenha = true;
      try {
        await service.login(
          'Login',
          'MakeLoginAssociado/codigoAcesso',
          this.form,
        );

        onSuccess();
        this.showModalCodigoVerificacao = false;
        this.showModalNovaSenha = true;
      } catch (err) {
        onError('Código inválido ou expirado');
      } finally {
        onFinish();
      }
    },

    isValidEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },

    async gerarCodigoResetSenha() {
      if (!this.validateTaxId()) {
        this.showMessage(
          'Por favor, preencha um CPF ou CNPJ válido.',
          'warning',
        );
        return;
      }
      if (!this.form.email || !this.isValidEmail(this.form.email)) {
        this.showMessage('Por favor, informe um e-mail válido.', 'warning');
        return;
      }
      try {
        this.submitLoading = true;
        this.form.email = this.form.email.toLowerCase();
        await service.login('Login', 'GerarCodigoValidacao', this.form);
        this.showModalCodigoVerificacao = true;
      } catch (err) {
        if (err === 'Login no app não permitido!') {
          this.empresaNaoPermiteAssociadoLogarApp = true;
        } else {
          this.showMessage(
            'Por favor, confirme os dados e tente novamente!',
            'warning',
          );
        }
      } finally {
        this.submitLoading = false;
      }
    },
    handleVerify(payload) {
      if (this.resetSenha) {
        return this.verificaoResetSenha(payload);
      }

      return this.verificaoLogin(payload);
    },

    async atualizarSenha({ senha, onSuccess, onError, onFinish }) {
      try {
        const { data } = await service.login('Login', 'EsqueciSenhaAssociado', {
          ...this.form,
          senha,
        });
        onSuccess();
        this.handleSuccessfulSignIn(data);
      } catch (err) {
        onError('Erro ao atualizar a senha.');
      } finally {
        onFinish();
      }
    },

    async senhaAtualizada() {
      this.showModalNovaSenha = false;
      this.showMessage('Senha atualizada com sucesso.', 'success');
    },
  },
  mounted() {
    // localStorage.removeItem('user-token');
    this.buscaDadosEmpresa();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-link {
  display: block;
  padding: 0.5rem 0.5rem;
}

.not-allowed-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 1.5rem;
}

.not-allowed-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 1.25rem;
  padding: 2.5rem 2rem;
  text-align: center;
  max-width: 360px;
  width: 100%;
  color: #fff;
}

.not-allowed-icon {
  margin: 0 auto 1rem;
  width: 64px;
  height: 64px;
  color: #e74c3c;
}

.not-allowed-icon svg {
  width: 100%;
  height: 100%;
}

.not-allowed-code {
  font-size: 4rem;
  font-weight: 800;
  color: #e74c3c;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.not-allowed-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 1rem;
}

.not-allowed-message {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin: 0;
}

.text-xl {
  font-size: 1.25rem;
}

.texto-placa {
  margin-top: 5px;
  font-size: 13px;
}
.link-senha {
  font-size: 13px;
  text-decoration: underline;
}
.login-input i {
  color: rgb(124, 124, 238) !important;
}
</style>
<style>
body.home {
  background: #000d37;
  width: 100%;
  height: 100%;
  min-height: 100%;
  background-size: cover;
}

.headerModalCotacao {
  background-color: rgb(16, 72, 129);
  color: white;
  border-radius: 20px 20px 0 0;
  padding: 1.5rem;
}

#modalCotacao footer button {
  width: 100%;
}

#modalCotacao .modal-dialog .modal-content {
  border-radius: 20px;
}

#modalCotacao {
  font-size: 1.5rem;
  width: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.placaChassiInput {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
}

.cotacaoEncontradaTrue {
  font-size: 1rem;
  margin-left: 1rem;
  font-weight: bold;
  color: #28a745;
}

.cotacaoEncontradaFalse {
  font-size: 1rem;
  margin-left: 1rem;
  font-weight: bold;
  color: #dc3545;
}

body.associado {
  background: #000d37;
}

body.consultor {
  background: #000d37;
}

body.home.carvip {
  background: #000d37;
}
body.associado.carvip {
  background: #000d37;
}
body.consultor.carvip {
  background: #000d37;
}

body.home.bp {
  background: #000d37;
}
body.associado.bp {
  background: #000d37;
}
body.consultor.bp {
  background: #000d37;
}
#Senha,
#Senha2 {
  padding-right: 4rem !important;
}

#eyeButton {
  position: absolute;
  right: 60px;
  margin-top: 5px;
  opacity: 0.3;
  font-size: 20px;
}

.w-100 {
  width: 100%;
}

.login-input {
  font-family: 'montserratbold';
  border-radius: 8px;
  height: calc(1.5em + 0.75rem + 10px);
  font-size: 16px;
  width: 100%;
  border: 2px solid #2b50bb;
}

.section-enter-data {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.label-input {
  font-family: 'montserrat';
  font-size: 0.825rem;
  color: #ffffff;
  padding-bottom: 0.25rem;
  margin-bottom: 0;
}

.label-input-checkbox {
  font-family: 'montserrat';
  font-size: 0.825rem;
  color: #ffffff;
  padding-top: 0.2rem;
}

.center-content {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.button-reset-password {
  font-family: 'montserratbold', sans-serif;
  background-color: transparent;
  color: #2b50bb;
  border-radius: 8px !important;
  padding: 10px 0px;
  font-size: 1rem;
  width: 100%;
  text-transform: none;
  margin-top: 20px;
  border: none;
}
.button-reset-password:focus,
.button-reset-password:active {
  color: #ffffff;
}
</style>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
